export default "__VITE_ASSET__DRpecJyq__"